import { render, staticRenderFns } from "./AdminApprovalPending.vue?vue&type=template&id=ee19200c&scoped=true"
import script from "./AdminApprovalPending.vue?vue&type=script&lang=js"
export * from "./AdminApprovalPending.vue?vue&type=script&lang=js"
import style0 from "./AdminApprovalPending.vue?vue&type=style&index=0&id=ee19200c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee19200c",
  null
  
)

export default component.exports